export const navLinks = [
  { label: "About", to: "home", offset: -80 },
  { label: "Services", to: "services", offset: -80 },
  { label: "Our Pride", to: "projects", offset: -80 },
  { label: "Contact", to: "contact", offset: -80 },
];

export const documentLinks = [
  {
    id: "iccp",
    label: "ICCP NON VAS CODE",
    title: "ICCP NON VAS CODE",
    fileName: "ICCP NON VAS CODE _SI_Omnicom.pdf",
    downloadName: "ICCP NON VAS CODE_SI_Omnicom.pdf",
  },
  {
    id: "osl-quality",
    label: "OSL Quality Policy Statement",
    title: "OSL QUALITY POLICY STATEMENT",
    fileName: "OSL QUALITY POLICY STATEMENT.pdf",
    downloadName: "OSL QUALITY POLICY STATEMENT.pdf",
  },
  {
    id: "osl-ohs",
    label: "OSL OHS Policy Statement",
    title: "OSL OHS POLICY STATEMENT",
    fileName: "OMNICOM OHS POLICY STATEMENT.pdf",
    downloadName: "OMNICOM OHS POLICY STATEMENT.pdf",
  },
];
